import { graphql } from "@/gql/__generated__";

export const followOfficeMutation = graphql(`
  mutation FollowOffice($input: FollowOfficeInput!) {
    followOffice(input: $input) {
      office {
        id
      }
      firstFavorite
    }
  }
`);

export const unfollowOfficeMutation = graphql(`
  mutation UnfollowOffice($input: UnfollowOfficeInput!) {
    unfollowOffice(input: $input) {
      office {
        id
      }
    }
  }
`);

export const viewerFavoriteGuideStatusQuery = graphql(`
  query ViewerFavoriteGuideStatus {
    viewer {
      id
      favoriteGuideDisplayed
    }
  }
`);

export const displayedFavoriteGuideMutation = graphql(`
  mutation DisplayedFavoriteGuide($input: DisplayedFavoriteGuideInput!) {
    displayedFavoriteGuide(input: $input) {
      viewer {
        id
        favoriteGuideDisplayed
      }
    }
  }
`);
